<template>
    <div class="description subtitle-2">
        <div class="short-description" v-if="showReadmore && description.length > 80">
            <span v-html="`${sliceCleanText}`"></span>
            <span @click="showFull" class='textLinks--text'>...read more</span>
        </div>
        <div v-if="!showReadmore" v-html="description" refs="fullDescription"></div>
    </div>
</template>
<script>
export default {
    props: ['description'],
    data: () => ({
        showReadmore: true
    }),

    computed: {
        sliceCleanText() {
            let cleanText = this.description.replace(/<\/?[^>]+(>|$)/g, "")
            return cleanText.slice(0, 80)
        }
    },

    methods: {
        showFull() {
            this.showReadmore = false
            setTimeout(() => {
                this.sanitizeLinks()
            }, 100)
        },

        sanitizeLinks() {
            const links = this.$el.getElementsByTagName('a')
            for (let i = 0; i < links.length; i++) {
                links[i].target = "_blank";
            }
        }
    }
}
</script>